import React from "react";
import PropTypes from "prop-types";
import FormInput from "../../../../../../Lib/FormInput";
import FormCard from "../../../../../../Lib/FormCard";

const GuestForm = ({
  formData,
  onChange,
  errors,
  disabled,
  index = 0,
  refs,
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  const radioName = index > 0 ? `gender-${index}` : "gender";

  return (
    <FormCard title={index > 0 ? `Guest Details ${index}` : "Guest Details"}>
      <div className="col-md-6">
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Booking Source <span className="text-danger"></span>
          </label>
          <div className="input-group">
            <span className="input-group-text">
              <i className="bi bi-globe2"></i>
            </span>
            <select
              className={`form-select ${
                errors.booking_source
                  ? "is-invalid"
                  : formData.source
                  ? "is-valid"
                  : ""
              }`}
              name="booking_source"
              value={formData.booking_source}
              onChange={handleInputChange}
              disabled={disabled}
            >
              <option value="">Select Source</option>
              <option value="Online Booking">Online Booking</option>
              <option value="Travel Agent">Travel Agent</option>
            </select>
            {errors.source && (
              <div className="invalid-feedback">{errors.source}</div>
            )}
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <FormInput
          label="Agent Name"
          icon="bi bi-person-circle"
          placeholder="Agent Name"
          value={formData.agent_name}
          onChange={handleInputChange}
          name="agent_name"
          disabled={disabled}
          error={errors.agent_name}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          ref={refs?.countryCode}
          label="Country Code"
          icon="bi bi-geo-alt"
          placeholder="Country Code"
          value={formData.countryCode}
          onChange={handleInputChange}
          name="countryCode"
          disabled={disabled}
          error={errors.countryCode}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          ref={refs?.mobileNo}
          label="Mobile No."
          icon="bi bi-phone"
          placeholder="Mobile No."
          value={formData.mobileNo}
          onChange={handleInputChange}
          name="mobileNo"
          disabled={disabled}
          error={errors.mobileNo}
          required={true}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="First Name"
          icon="bi bi-person-circle"
          placeholder="First Name"
          value={formData.first_name}
          onChange={handleInputChange}
          name="first_name"
          disabled={disabled}
          required={true}
          error={errors.first_name}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          ref={refs?.last_name}
          label="Last Name"
          icon="bi bi-person-circle"
          placeholder="Last Name"
          value={formData.last_name}
          onChange={handleInputChange}
          name="last_name"
          disabled={disabled}
          error={errors.last_name}
          required={true}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="Father Name"
          icon="bi bi-person-circle"
          placeholder="Father Name"
          value={formData.fatherName}
          onChange={handleInputChange}
          name="fatherName"
          disabled={disabled}
          error={errors.fatherName}
        />
      </div>
      <div className="col-md-6 align-self-center">
        <label className="form-label text-muted w-100">Gender</label>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name={radioName}
            id={`inlineRadio1-${index}`}
            value="Male"
            checked={formData.gender === "Male"}
            onChange={() => onChange("gender", "Male")}
            disabled={disabled}
          />
          <label className="form-check-label" htmlFor={`inlineRadio1-${index}`}>
            Male
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name={radioName}
            id={`inlineRadio2-${index}`}
            value="Female"
            checked={formData.gender === "Female"}
            onChange={() => onChange("gender", "Female")}
            disabled={disabled}
          />
          <label className="form-check-label" htmlFor={`inlineRadio2-${index}`}>
            Female
          </label>
        </div>
        {errors.gender && (
          <div className="text-danger small mt-1">{errors.gender}</div>
        )}
      </div>
      <div className="col-md-6">
        <FormInput
          label="Occupation"
          icon="bi bi-briefcase"
          placeholder="Occupation"
          value={formData.occupation}
          onChange={handleInputChange}
          name="occupation"
          disabled={disabled}
          error={errors.occupation}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="Date of Birth"
          type="date"
          icon="bi bi-calendar"
          placeholder="Date of Birth"
          value={formData.dob}
          onChange={handleInputChange}
          name="dob"
          disabled={disabled}
          error={errors.dob}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label text-muted">Guest</label>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id={`defaultCheck1-${index}`}
            checked={formData.isVIP}
            onChange={(e) => onChange("isVIP", e.target.checked ? "true" : "")}
            disabled={disabled}
          />
          <label
            className="form-check-label"
            htmlFor={`defaultCheck1-${index}`}
          >
            VIP?
          </label>
        </div>
      </div>
    </FormCard>
  );
};

GuestForm.propTypes = {
  formData: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number,
};

export default GuestForm;
